module.exports = __webpack_public_path__ + "img/hero_mobile_4.8203d6e0.webp";